import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import CompaniesForm from 'components/Admin/Companies/Form';
import ContractsForm from 'components/Admin/Contracts/Form';

import './index.scss';

export interface FormSheetProps {
  companyOpen: boolean,
  companyTitle: string,
  companyId: number,
  contractId: number,
  dismissCompany: () => void,
  contractOpen: boolean,
  contractTitle: string,
  dismissContract: () => void,
}

/**
 * Reaproveita os formularios reais do desktop (CompaniesForm / ContractsForm)
 * dentro de BottomSheets, sem duplicar logica de formulario. Sao dois sheets
 * porque sao dois fluxos distintos: empresa (+ primeiro contrato) e contrato
 * novo para empresa existente.
 */
export default function FormSheet({
  companyOpen,
  companyTitle,
  companyId,
  contractId,
  dismissCompany,
  contractOpen,
  contractTitle,
  dismissContract,
}: FormSheetProps) {
  return (
    <>
      <BottomSheet
        open={companyOpen}
        dismiss={dismissCompany}
        title={companyTitle}
        className="admin-form-sheet"
      >
        <CompaniesForm companyId={companyId} contractId={contractId} />
      </BottomSheet>
      <BottomSheet
        open={contractOpen}
        dismiss={dismissContract}
        title={contractTitle}
        className="admin-form-sheet"
      >
        <ContractsForm />
      </BottomSheet>
    </>
  );
}
